
// vue
import { defineComponent, onMounted, ref, computed,  } from 'vue';

// icons
import { add, close } from 'ionicons/icons';

// components
import {
  IonPage,
  IonGrid,
  IonInput, IonTextarea,
  IonIcon,
  IonFooter,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonTitle,
  IonSearchbar,
  IonToolbar,
  IonCol, IonRow, IonLabel, IonCard,
  modalController,
  loadingController
} from '@ionic/vue';
import RoleInClassSelectModal from '@/components/teacher/RoleInClassSelectModal.vue';

// composables
import config from '@/config';
import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';

// services
import TeacherService from '@/services/TeacherService';

export default defineComponent({
  name: 'RoleInClassesModal',
  props: ["hideHeader", "prefilledRolesInClasses"],
  components: {
    IonPage,
    IonGrid,
    IonInput, IonTextarea,
    IonIcon,
    IonFooter,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonItem,
    IonList,
    IonTitle,
    IonSearchbar,
    IonToolbar,
    IonCol, IonRow, IonLabel, IonCard,
  },
  setup(props) {
    // methods
    const { t } = useI18n();
    const { formatDate, presentToast, presentAlert, presentPrompt, uniqueId } = utils();

    // State
    const store = useStore();
    const user = computed(() => store.state.user);
    const activeClassRoles = () => ((user.value.teacher?.classRoles || []).filter(cr => cr.status != 'removed'));
    const searchKeyword = ref(""); // TBC: for searching class / subjects?
    const rolesInClasses = ref([{
      id: `ric${uniqueId()}`,
      role: "",
      classes: "",
      remarks: "",
    }]);

    onMounted(() => {
      const { prefilledRolesInClasses } = props;
      if (prefilledRolesInClasses && prefilledRolesInClasses.length > 0) {
        rolesInClasses.value = prefilledRolesInClasses;
      }
    })

    return {
      // icon
      add, close,

      // variables
      searchKeyword,
      rolesInClasses,

      // methods
      t,
      cancelChanges: async () => (await modalController.dismiss({})),
      confirmChanges: async () => {
        if (props.hideHeader) { // from TeacherRolesModal
          const loading = await loadingController.create({});
          await loading.present();

          // Check remove class roles (set status to removed)
          const removedClassRoles: any = activeClassRoles().filter(acr => (rolesInClasses.value.find(cr => cr.id == acr.id) == null));
          const updatedClassRoles = rolesInClasses.value.concat(removedClassRoles.map(rcr => {
            rcr.status = 'removed';
            return rcr;
          }));
          TeacherService.updateTeacher(user.value, { classRoles: updatedClassRoles });
          store.commit('upsertTeacherClassRoles', updatedClassRoles);
          presentToast("Saved successfully!");

          loading.dismiss();
        }
        else {
          await modalController.dismiss({ rolesInClasses: rolesInClasses.value })
        }
      },

      incrementRoleInClass: () => {
        rolesInClasses.value.push({
          id: `ric${uniqueId()}`,
          role: "",
          classes: "",
          remarks: "",
        })
      },
      removeRoleInClass: (idx) => {
        rolesInClasses.value.splice(idx, 1);
      },

      openRoleInClassSelectModal: async (idx, prefilledRole, classes, initialSection = 1) => {
        const modal = await modalController.create({
          component: RoleInClassSelectModal,
          componentProps: { initialSection, prefilledRole, prefilledClasses: classes ? classes.split(" , ") : [] },
        });
        modal.onDidDismiss().then(({ data }) => {
          if (data && data.selectedRole) {
            const targetObj = rolesInClasses.value[idx];
            targetObj.role = data.selectedRole;
            targetObj.classes = data.selectedClasses.sort().join(" , ");
            if (prefilledRole != data.selectedRole) targetObj.id = `ric${uniqueId()}`; // role change: gen new row to keep records
          }
        });
        return modal.present();
      },
    }
  },
});
